export type SdkPropTypes = 'string' | 'boolean' | 'number';

/**
 *
 * @param type string , boolean , number
 * @param input input value
 */
export function SdkTypeCheck(type: SdkPropTypes, input: unknown) {
  if (typeof input !== type) {
    throw new TypeError(`[SDK] ${input} is not typeof ${type}`);
  }
}
